import * as React from "react";
import styled from "styled-components";
import { UnstyledLink } from "Components/Shared/Routes/UnstyledLink";

type Props = {
  breadcrumbItems: BreadcrumbItem[];
};

export interface BreadcrumbItem {
  name: string;
  url?: string;
}

const StyledBreadcrumbsWrapper = styled.div``;

const StyledBreadcrumbs = styled.ul`
  padding-left: 0;
  list-style: none;

  .breadcrumb-item + .breadcrumb-item:before {
    padding-right: 3px;
  }
`;

const StyledBreadcrumb = styled.li`
  .go-back {
    cursor: pointer;
  }
`;

export const Breadcrumbs: React.FunctionComponent<Props> = props => {
  const { breadcrumbItems } = props;

  return (
    <StyledBreadcrumbsWrapper>
      <StyledBreadcrumbs className={"breadcrumb"}>
        {breadcrumbItems.map((menuItem, index) => (
          <StyledBreadcrumb key={index} className={"breadcrumb-item"}>
            {menuItem.url ? (
              <UnstyledLink to={`/${menuItem.url}`}>
                {menuItem.name}
              </UnstyledLink>
            ) : (
              <span>{menuItem.name}</span>
            )}
          </StyledBreadcrumb>
        ))}
      </StyledBreadcrumbs>
    </StyledBreadcrumbsWrapper>
  );
};
